KMVP.kmcQuoteHeaderIcon = {
    addTheCounterIcon: function (count) {
        $('.js-quote-link').before(
            "<div class='minicart-item-amount-wrapper'>" +
                "<div class='minicart-item-amount js-minicart-item-amount-KMC-QUOTE'>" + count + "</div>" +
            "</div>"
        );
    },
    checkUnreadQuoteNumber: function () {
        var count = $('[data-unread-quotes-number]').data("unreadQuotesNumber");
        if (count) {
            KMVP.kmcQuoteHeaderIcon.addTheCounterIcon(count);
        }
    }
};

$(document).ready(function () {
    KMVP.kmcQuoteHeaderIcon.checkUnreadQuoteNumber();
});
